import React from 'react';
import './Hom.css';

export default function English() {
    return <h1 className = 'services' > WELCOME to English Class </h1>         
}